<template ref="AddEditEst" >
    <div>
        <vs-popup :title="(!editing) ? 'Añadir Establecimiento' : 'Actualizar Establecimiento'" :active.sync="activePopup" :class="(rol === 'buyer') ? 'establishment-popup buyer' : 'establishment-popup seller'" class="entity-popup">
        <div class="establishment-form">
          <vs-input v-if="isBuyer" name="number"
                    data-test="input-number"
                    size="large"
                    v-validate="validateAttr('number')"
                    :danger="this.errors.has('number')"
                    :danger-text="this.errors.first('number')"
                    label-placeholder="Número Establecimiento"
                    v-model="newEstablishment.number"/>
          <vs-input v-if="isBuyer" name="ruca"
                    data-test="input-ruca"
                    size="large"
                    v-validate="validateAttr('ruca')"
                    :danger="this.errors.has('ruca')"
                    :danger-text="this.errors.first('ruca')"
                    v-mask="'#####'"
                    label-placeholder="Matrícula RUCA"
                    v-model="newEstablishment.ruca"/>
          <vs-input name="name"
                    data-test="input-nameest"
                    test = "nameseller"
                    size="large"
                    v-validate="'required|max:30'"
                    :danger="this.errors.has('name')"
                    :danger-text="this.errors.first('name')"
                    label-placeholder="Nombre Establecimiento"
                    v-model="newEstablishment.name"/>
          <vs-input v-if="isSeller" name="renspa"
                    data-test="input-renspa"
                    v-validate="{required: true, regex: /(0[0-9]|1[0-9]|2[0-4])\.\d{3}\.\d{1}\.\d{5}\/\d{2}/i }"
                    :danger="this.errors.has('renspa')"
                    :danger-text="this.errors.first('renspa')"
                    v-mask="'##.###.#.#####/##'"
                    size="large"
                    label-placeholder="RENSPA"
                    v-model="newEstablishment.renspa"/>
          <vs-input v-if="isSeller" name="cuig"
                    data-test="input-cuig"
                    v-validate="'length:5'"
                    :danger="this.errors.has('cuig')"
                    :danger-text="this.errors.first('cuig')"
                    v-mask="'SS###'"
                    size="large"
                    label-placeholder="CUIG"
                    v-model="newEstablishment.cuig"/>
          <div class="input-group">
            <select name="state"
                    data-test="select-state"
                    data-state="select-stateBuyer"
                    v-validate="'required'"
                    :danger="this.errors.has('state')"
                    size="large"
                    @change="getCities($event.target.value)"
                    :class="{changed: !!(newEstablishment.state)}"
                    v-model="newEstablishment.state">
              <option value="" disabled>Provincia</option>
              <option :key="index" :value="state.name" :text="state.name" v-for="(state,index) in states">{{ state.name }}</option>
            </select>
            <label for="state">Provincia</label>
            <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
              <span> {{ this.errors.first('state') }}</span>
            </div>
          </div>
          <div class="input-group">
            <select name="city"
                    data-test="select-city"
                    v-validate="'required'"
                    :danger="this.errors.has('city')"
                    size="large"
                    :class="{changed: !!(newEstablishment.city)}"
                    v-model="newEstablishment.city">
              <option value="" disabled>Ciudad</option>
              <option :key="index" :value="city.name" :text="city.name" v-for="(city,index) in cities">{{ city.name }}</option>
            </select>
            <label for="state">Localidad</label>
            <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
              <span> {{ this.errors.first('city') }}</span>
            </div>
          </div>
          <vs-input name="cp"
                    data-test="input-cp"
                    size="large"
                    label-placeholder="CP"
                    v-model="newEstablishment.zipcode"
                    :danger="this.errors.has('cp')"
                    :danger-text="this.errors.first('cp')"
                    v-validate="'required|min:4|max:6|alpha_dash'"/>
          <div class="input-group" v-if="isBuyer">
            <select name="activity"
                    data-test="select-activity"
                    v-validate="'required'"
                    :danger="this.errors.has('activity')"
                    size="large"
                    :class="{changed: !!(newEstablishment.activity)}"
                    v-model="newEstablishment.activity">
              <option value="" disabled>Actividad</option>
              <option :key="index" :value="activity" :text="activity" v-for="(activity,index) in activitiesList">{{ activity }}</option>
            </select>
            <label for="state">Actividad</label>
            <div data-test="select-activity" class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
              <span> {{ this.errors.first('activity') }}</span>
            </div>
          </div>
        </div>
        <div v-if="establishmentErrors" class="o-alert o-alert--danger">{{ establishmentErrors }}</div>
        <div class="vs-popup--footer">
          <vs-button data-test="button-cancel" color="grey" type="filled" @click="dismissPopup">Cancelar</vs-button>
          <vs-button data-test="button-create" color="success" type="filled" @click="createEstablishment">{{ (!editing) ? 'Crear' : 'Guardar' }}</vs-button>
        </div>
      </vs-popup>
    </div>
</template>

<script>
import AddEditEstablishments from './AddEditEstablishment'
import { mapMutations, mapState } from 'vuex'
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { Validator } from 'vee-validate'
/*import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/translations/I18n/messages.js'
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'es', // set locale
  messages // set locale messages
})  */

const fetchCountries = gql`
  query fetchCountries {
    fetchCountries {
      name
      id
    }
  }
`

const fetchStates = gql`
  query fetchStates($countryId: Int!) {
    fetchStates(countryId: $countryId) {
      name
      id
    }
  }
`

const fetchCities = gql`
  query fetchCities($stateId: Int!) {
    fetchCities(stateId: $stateId) {
      name
    }
  }
`

const selectableActivities = gql`
  query retrieveSelectableAttributes($object: String!, $objId: Int, $attribute: String!) {
    retrieveSelectableAttributes(object: $object, objId: $objId, attribute: $attribute) {
      success
      selectableAttributes
    }
  }
`

const validateAttr = gql`
  query validateAttribute($object: String!, $attribute: String!, $value: String!) {
    validateAttribute(object: $object, attribute: $attribute, value: $value) {
      message
      success
      code
    }
  }
`

const EstablishmentMutation = gql`
  mutation createEstablishment($roleIds: [Int!]!, $cuig: String, $renspa: String, $number: String, $name: String!, $zipcode: String!, $activity: String, $sanitaryProfile: String!, $organizationId: Int!, $ruca: String, $city: String!, $state: String!, $currentUserToken: String!) {
    createEstablishment(roleIds: $roleIds, cuig: $cuig, renspa: $renspa, number: $number, name: $name, zipcode: $zipcode, activity: $activity, sanitaryProfile: $sanitaryProfile, organizationId: $organizationId, ruca: $ruca, city: $city, state: $state, currentUserToken: $currentUserToken) {
      name
    }
  }
`

const updateEstablishmentMutation = gql`
  mutation updateEstablishment($establishmentId: Int!, $active: Boolean, $name: String, $zipcode: String, $city: String, $state: String, $activity: String, $ruca: String, $cuig: String, $renspa: String, $number: String, $sanitaryProfile: String, $currentUserToken: String!) {
    updateEstablishment(establishmentId: $establishmentId, active: $active, name: $name, zipcode: $zipcode, city: $city, state: $state, activity: $activity, ruca: $ruca, cuig: $cuig, renspa: $renspa, number: $number, sanitaryProfile: $sanitaryProfile, currentUserToken: $currentUserToken) {
      code
      success
      message
    }
  }
`

const fetchRoles = gql`
  query fetchRoles($names: [String!]) {
    fetchRoles(names: $names) {
      id
      name
    }
  }
`

export default {
  name: 'add-edit-establishment',
  beforeMount () {
    this.fetchRoles()
    this.getCountries()
    this.getActivities()
  },
  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser,
      buyerEstablishments: state => state.SignUp.establishments.buyer
    }),
    isBuyer () {
      return (this.rol === 'buyer')
    },
    isSeller () {
      return (this.rol === 'seller')
    },
    isMix () {
      return (this.rol === 'buyer' && 'seller')
    }
  },
  watch: {
    editEstablishments() {
      if (editEstablishments) {
        this.newEstablishment = this.editEstablishments
      }
    },
    'newEstablishment.state' () {
      if (this.newEstablishment.state) {
        this.getCities(this.newEstablishment.state)
      }
    }
  },
  data () {
    return {
      newEstablishment: { country: '', status: true },
      countries: [],
      states: [],
      cities: [],
      activitiesList: [],
      activePopup: false,
      editing: '',
      roles: [],
      establishmentErrors: ''
    }
  },
  props: {
    number: '',
    editEstablishments: '',
    rol: {
      type: String,
      required: false,
      default: 'buyer'
    },
    vuex: {
      type: Boolean,
      required: false,
      default: true
    },
    error: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    ...mapMutations('SignUp', [
      'pushEstablishment',
      'removeEstablishment',
      'toggleStatusEstablishment',
      'updateEstablishment'
    ]),
    validateAttr(attr){
      if(!this.editing) {
        return `required|numeric|max:10|validateOnDB:establishment,${attr}`
      }
      return 'required|numeric|max:10'
    },
    createEstablishment () {
      this.$validator.validate().then((res) => {
        if (res) {
          if (!this.editing) {
            if (this.vuex) {
              this.pushEstablishment({ rol: this.rol, value: this.newEstablishment })
              this.resetData()
            } else {
              this.createStablishment(this.rol, this.newEstablishment)
            }
          } else {
            if (this.vuex) {
              this.updateEstablishment({ rol: this.rol, name: this.editing, value: this.newEstablishment })
              this.resetData()
            } else {
              this.updateEstablishmentGraph(this.newEstablishment)
            }
          }
        } else {
          return false
        }
      })
    },
    resetData () {
      this.dismissPopup()
      this.newEstablishment = { country: '', state: '', city: '', status: true }
      this.getCountries()
      this.editing = ''
      this.establishmentErrors = ''
    },
    createStablishment (roleId, establishment) {
      var sellerAttr = {
        renspa: establishment.renspa,
        cuig: establishment.cuig
      }
      var buyerAttr = {
        number: establishment.number,
        ruca: establishment.ruca,
        activity: establishment.activity,
      }
      var auxAttr = ''
      if (roleId == 'buyer') {
        auxAttr = buyerAttr
      } else {
        auxAttr = sellerAttr
      }
      roleId = this.roles.find(e => e.name === roleId).id
      return axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
        query: print(EstablishmentMutation),
        variables: Object.assign ({
          roleIds: [roleId],
          name: establishment.name,
          state: establishment.state,
          city: establishment.city,
          zipcode: establishment.zipcode,
          sanitaryProfile: 'Example',
          organizationId: this.currentUser.organizationId,
          currentUserToken: localStorage.getItem('USER_TOKEN')
        }, auxAttr )
      }).then(res => {
        if (!res.data.errors) {
          if (res.data.data.createEstablishment.code == "unauthorized") {
            this.$vs.notify({
              title: 'No tiene permisos para realizar esta acción',
              time: 3000,
              //text: 'Por favor intente nuevamente',
              color: '#DE3618',
              position: 'top-right',
              icon: 'error'
            })
          } else {
            this.$emit('get-establishments')
            this.resetData()
          }
        } else {
          console.log(res.data.errors)
          var text = ''
          if ("Invalid Attributes for Establishment: Renspa has already been taken" == (res.data.errors[0].message)) {text = 'Renspa ya está en uso'}
          if ("Invalid Attributes for Establishment: Renspa is invalid" == (res.data.errors[0].message)) {text = 'Renspa es invalido'}
          if (/Cuig/.test(res.data.errors[0].message)) {text = 'Cuig ya está en uso'}
          this.establishmentErrors = text
        }
      }).catch(err => {
        console.log(err)
      })
    },
    updateEstablishmentGraph(establishment) {
      axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
        query: print(updateEstablishmentMutation),
        variables: {
          establishmentId: establishment.id,
          active: establishment.active,
          name: establishment.name,
          zipcode: establishment.zipcode,
          city: establishment.city,
          state: establishment.state,
          activity: establishment.activity,
          sanitaryProfile: establishment.sanitaryProfile,
          renspa: establishment.renspa,
          cuig: establishment.cuig,
          number: establishment.number,
          ruca: establishment.ruca,
          currentUserToken: localStorage.getItem('USER_TOKEN')
        }
      }).then(res => {
        if (res.data.data.updateEstablishment.success) {
          this.$emit('get-establishments')
          this.resetData()
        } else {
          if (res.data.data.updateEstablishment.code == "unauthorized") {
            this.$vs.notify({
              title: 'No tiene permisos para realizar esta acción',
              time: 3000,
              //text: 'Por favor intente nuevamente',
              color: '#DE3618',
              position: 'top-right',
              icon: 'error'
            })
          } else {
            console.log(res.data.data.updateEstablishment.message)
            var text = ''
            //  if (/Renspa/.test(res.data.errors[0].message)) {text = 'Renspa ya está en uso'}
            if ("Invalid Attributes for Establishment: Renspa has already been taken" == (res.data.errors[0].message)) {text = 'Renspa ya está en uso'}
            if ("Invalid Attributes for Establishment: Renspa is invalid" == (res.data.errors[0].message)) {text = 'Renspa es invalido'}
            if (/Cuig/.test(res.data.errors[0].message)) {text = 'Cuig ya está en uso'}
            this.establishmentErrors = text
          }
        }
      }).catch( err => {
        console.log(err)
      })
    },
    fetchRoles() {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchRoles),
        variables: {
          names: []
        }
      }}).then(res => {
        if (!res.data.errors) {
          this.roles = res.data.data.fetchRoles
        }else{
          console.log(res.data.errors)
        }
      }).catch(err =>{
        console.log(err)
      })
    },
    //deleteEstablishment(id) {
    //  axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
    //    query: print(destroyEstablishment),
    //    variables: {
    //      establishmentId: id
    //    }
    //  }).then(res => {
    //    if(!res.data.errors) {
    //      this.deleting = ''
    //      this.$emit('reload-establishments')
    //      this.confirmDelete = false
    //    }
    //  }).catch(err => {
    //    console.log(err)
    //  })
    //},
    editEstablishment (name) {
      if (this.vuex) {
        this.newEstablishment = this.$store.getters['SignUp/getEstablishment']({ rol: this.rol, name: name }) //  TODO: cambiar param name a number o a id
      } else {
        this.newEstablishment = {...this.$store.getters['SignUp/getEstablishment']({ rol: this.rol, name: name })}
      }
      this.newEstablishment.state = this.newEstablishment.state.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      this.newEstablishment.city = this.newEstablishment.city.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      this.editing = name
      this.activePopup = true
    },
    getLocalizationId (arrayName, name) {
      name = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      return this[arrayName].find(q => q.name === name).id
    },
    getActivities () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(selectableActivities),
        variables: {
          object: 'establishment',
          attribute: 'activity'
        }
      }}).then(res => {
        if (!res.data.errors) {
          if (res.data.data.retrieveSelectableAttributes.success) {
            this.activitiesList = res.data.data.retrieveSelectableAttributes.selectableAttributes
          }
        }
      })
    },
    getCountries () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchCountries)
      }}).then(res => {
        if (res.data.errors) {
          console.log(res.data.errors)
        } else {
          this.newEstablishment.state = ''
          this.newEstablishment.city = ''
          this.countries = res.data.data.fetchCountries
          this.getStates('Argentina')
        }
      })
    },
    getStates (countryName) {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchStates),
        variables: {
          countryId: this.getLocalizationId('countries', countryName)
        }
      }}).then(res => {
        if (res.data.errors) {
          console.log(res.data.errors)
        } else {
          this.newEstablishment.city = ''
          this.states = res.data.data.fetchStates
        }
      })
    },
    getCities (stateName) {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchCities),
        variables: {
          stateId: this.getLocalizationId('states', stateName)
        }
      }}).then(res => {
        if (res.data.errors) {
          console.log(res.data.errors)
        } else {
          this.cities = res.data.data.fetchCities
        }
      })
    },
    dismissPopup () {
      this.activePopup = false
      this.newEstablishment = { country: '', state: '', city: '', status: true, activity: "" }
    },
    openPopup () {
      this.newEstablishment = { country: '', state: '', city: '', status: true, activity: "" }
      this.editing = ''
      this.activePopup = true
    },
    flashErrorStablishments () {
      let alert = document.querySelector('#alertStablishment')
      alert.classList.remove('info')
      alert.classList.add('danger')
      alert.classList.add('pop')

      setTimeout(function () {
        alert.classList.add('info')
        alert.classList.remove('danger')
        alert.classList.remove('pop')
      }, 500)
    }
  }
}
</script>
